import { downgrade_path } from '@routes';

import request from './request';

export interface DowngradeRequest {
  offer?: string;
}

export interface DowngradeResponse {
  message?: string;
  redirectUri?: string;
  success: boolean;
}

export async function downgrade(params: DowngradeRequest) {
  const resp = await request('post', downgrade_path(), params);
  return resp;
}
